import { clearAdministrationTablePreferences } from "../administration/tablePreferences";

export const PERSISTENCE_PREFIXES = [
  "vend:lastRouteBySection",
  "vend:lastSearch:",
  "vend:cadenceFilter:",
  "vend:range:",
  "routePlanner.",
  "routes.",
  "locations.",
  "vendistri.expenses.",
  "vendistri.inventory.",
] as const;

export function buildRangeStorageKey({
  scope,
  entityId,
  viewMode,
  pathname,
}: {
  scope: string;
  entityId?: string | null;
  viewMode?: string | null;
  pathname?: string | null;
}) {
  const mode = viewMode || "default";
  const route = pathname || "unknown";
  const id = entityId || "global";
  return `vend:range:${mode}:${scope}:${id}:${route}`;
}

export function clearPersistenceStorage(storage: Storage) {
  try {
    clearAdministrationTablePreferences(storage);
    const keys: string[] = [];
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (!key) continue;
      if (PERSISTENCE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        keys.push(key);
      }
    }
    keys.forEach((key) => storage.removeItem(key));
  } catch (_error) {
    // ignore storage failures
  }
}

export function clearAllSessionStorage(storage: Storage) {
  try {
    storage.clear();
  } catch (_error) {
    // ignore storage failures
  }
}
